import { render } from "./IncompleteKyc.vue?vue&type=template&id=c0b3afc6&scoped=true&ts=true"
import script from "./IncompleteKyc.vue?vue&type=script&lang=ts"
export * from "./IncompleteKyc.vue?vue&type=script&lang=ts"

import "./IncompleteKyc.vue?vue&type=style&index=0&id=c0b3afc6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0b3afc6"],['__file',"src/components/kyc/IncompleteKyc.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c0b3afc6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c0b3afc6', __exports__)) {
    api.reload('c0b3afc6', __exports__)
  }
  
  module.hot.accept("./IncompleteKyc.vue?vue&type=template&id=c0b3afc6&scoped=true&ts=true", () => {
    api.rerender('c0b3afc6', render)
  })

}


export default __exports__